<template>
  <FlexLayout
    class="plans-navigation"
    direction="column"
  >
    <BaseButton
      v-for="filter in FILTERS"
      :key="filter.value"
      color="neutral"
      variant="transparent"
      @click="handleFilterClick(filter.value)"
    >
      <BaseIcon
        v-show="filter.value === activeFilter"
        :id="filter.icon"
        weight="fill"
      />
      <BaseIcon
        v-show="filter.value !== activeFilter"
        :id="filter.icon"
        weight="regular"
      />
      {{ filter.label }}
    </BaseButton>
  </FlexLayout>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';

import { FILTERS } from '@/constants/filters';
import { usePlansQueryStore } from '@/stores/plansQuery';

const route = useRoute();
const router = useRouter();
const plansQueryStore = usePlansQueryStore();

const activeFilter = computed(() => plansQueryStore.filter);

const handleFilterClick = async (filterValue: string) => {
  await plansQueryStore.updateFilter(router, route, filterValue);
};
</script>

<style scoped>
.plans-navigation {
  display: flex;
  flex-direction: column;
  padding: var(--gap-sm) var(--gap-xs);
  gap: 0;
  position: relative;
  width: 12.5rem;
  .base-button {
    gap: var(--gap-sm);
    white-space: nowrap;
  }
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: var(--visible-width);
    height: 100%;
    background: var(--color-light);
    border: 1px solid var(--color-neutral-300);
    border-radius: 0 var(--border-radius-md) var(--border-radius-md) 0;
    z-index: -1;
    transition: var(--transition-default);
  }
}
</style>
